// core
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

// states
import { AuthState } from '@data/state';

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(private router: Router, private store: Store) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentUser = this.store.selectSnapshot(AuthState.currentUser);

        if (currentUser?.user?.role == 'applicationViewer' || currentUser?.user?.role == 'tenantViewer') {
            this.router.navigate(['dashboard']);
            return false;
        }

        return true;
    }
}
